import {
  CLEAR_PLAYER_DATA,
  FETCH_PLAYER_GET_MEDIA_ERRROR,
  FETCH_PLAYER_GET_MEDIA_INIT,
  FETCH_PLAYER_GET_MEDIA_SUCCESS,
  FETCH_LIVE_PLAYER_IS_BROKEN,
  SET_COUNTER_HBO_ERROR,
} from 'containers/Player/actions/player/constants';

const initialState = {
  loading: null,
  data: null,
  error: null,
  liveIsBroken: null,
  request: null,
  counterErrorHbo: 0,
  hasResetRetry: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PLAYER_GET_MEDIA_INIT:
      return {
        ...state,
        loading: true,
        data: null,
        error: null,
        liveIsBroken: null,
      };
    case FETCH_PLAYER_GET_MEDIA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.data,
        error: null,
        liveIsBroken: null,
        request: action.request,
        counterErrorHbo: 0,
        hasResetRetry: true,
      };
    case FETCH_PLAYER_GET_MEDIA_ERRROR:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.error,
        liveIsBroken: null,
      };
    case FETCH_LIVE_PLAYER_IS_BROKEN:
      return {
        ...state,
        loading: false,
        data: null,
        error: null,
        liveIsBroken: true,
      };
    case SET_COUNTER_HBO_ERROR:
      return {
        ...state,
        counterErrorHbo: action.payload,
      };
    case CLEAR_PLAYER_DATA:
      return initialState;
    default:
      return state;
  }
};
